import { render, staticRenderFns } from "./zc-table.vue?vue&type=template&id=18c0ba3c&scoped=true"
import script from "./zc-table.vue?vue&type=script&lang=js"
export * from "./zc-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c0ba3c",
  null
  
)

export default component.exports